import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { RoutingService, TranslationService, UrlPipe, TranslatePipe } from '@spartacus/core';
import { Observable } from 'rxjs';
import { CustomerData } from 'src/app/models/customer.model';
import { KnBrDateHelper } from 'src/app/shared/kn-br-date.helper';
import { KnBrCustomerContextService } from 'src/app/store/kn-br-customer-context/kn-br-customer-context.service';
import { KnBrOrderHistoryService } from 'src/app/store/kn-br-order-history/kn-br-order-history.service';
import { WIDGET_PAGESIZE } from 'src/constants/pagination.constant';
import { KnBrOrderHistorySearchResultComponent } from '../../kn-br-order-history/kn-br-order-history-search-result/kn-br-order-history-search-result.component';
import { KnBrCommonService } from 'src/app/services/kn-br-common.service';
import { NgbInputDatepicker } from '@ng-bootstrap/ng-bootstrap';
import { NgClass, AsyncPipe } from '@angular/common';
import { PaginationComponent, SpinnerComponent } from '@spartacus/storefront';
import { RouterLink } from '@angular/router';
import { RemoveLeadingZerosPipe } from '../../../shared/pipe/kn-br-custom-pipes/remove-leading-zeros.pipe';

@Component({
    selector: 'knbr-kn-br-quick-order-histroy',
    templateUrl: './kn-br-quick-order-histroy.component.html',
    styleUrls: ['./kn-br-quick-order-histroy.component.scss'],
    imports: [ReactiveFormsModule, NgbInputDatepicker, NgClass, PaginationComponent, RouterLink, SpinnerComponent, AsyncPipe, UrlPipe, TranslatePipe, RemoveLeadingZerosPipe]
})
export class KnBrQuickOrderHistroyComponent extends KnBrOrderHistorySearchResultComponent implements OnInit, OnDestroy {
  orderHistorySearchForm: UntypedFormGroup;
  customerContextData$: Observable<CustomerData> = this.knBrCustomerContextService.get$;
  currentPage = 0;
  isSearchDisabled$: Observable<boolean> = this.knBrOrderHistoryService.isSearchDisabled$;
  todayDate = () => {
    const today = new Date();
    return ({ year: today.getFullYear(), month: today.getMonth() + 1, day: today.getDate() });
  };
  maxStartDate = () => this.todayDate();
  maxEndDate = () => this.todayDate();
  constructor(
    public knBrOrderHistoryService: KnBrOrderHistoryService,
    protected routeService: RoutingService,
    protected knBrCustomerContextService: KnBrCustomerContextService,
    protected translation: TranslationService,
    private fb: UntypedFormBuilder,
    private knBrDateHelper: KnBrDateHelper,
    protected knBrCommonService: KnBrCommonService
  ) {
    super(knBrOrderHistoryService, routeService, knBrCustomerContextService, knBrCommonService, translation);
  }

  ngOnInit() {
    super.ngOnInit();
    this.customerContextData$.subscribe((value) => {
      this.initForm(value);
    });
    this.submitForm();
  }

  initForm(customerData) {
    this.orderHistorySearchForm = this.fb.group({
      accountNumber: customerData ? customerData.customerNumber : null,
      accountName: customerData ? customerData.customerName : null,
      salesOrderNumber: null,
      purchaseOrderNumber: null,
      jobName: null,
      startDate: null,
      endDate: null,
      currentPage: this.currentPage,
      pageSize: WIDGET_PAGESIZE,
      isWidget: true,
    });
  }

  submitForm() {
    const formValues = this.orderHistorySearchForm.getRawValue();
    if (this.orderHistorySearchForm.controls.startDate.value) {
      formValues.startDate = this.knBrDateHelper.formatDate(this.orderHistorySearchForm.controls.startDate.value);
    }
    if (this.orderHistorySearchForm.controls.endDate.value) {
      formValues.endDate = this.knBrDateHelper.formatDate(this.orderHistorySearchForm.controls.endDate.value);
    }
    this.knBrOrderHistoryService.search(formValues);
  }

  pageChange(page: number): void {
    if (this.searchCriteria) {
      this.searchCriteria.currentPage = page;
    }
    this.knBrOrderHistoryService.search(this.searchCriteria);
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }
}
